module.exports = __webpack_public_path__ + "media/images/talent/case5-badge-ae65166420cf22dd6e8b046432784e4a.png";